<template>
  <div>
    <div class="check_tool">
      <div class="check_tool__function">
        <div class="check_tool__function__load">
          <b-form-input v-model="email" placeholder="Email" class="check_tool__function__load__input"></b-form-input>
          <b-form-input v-model="count" placeholder="Count" class="check_tool__function__load__input"></b-form-input>
          <b-button class="check_tool__function__load__btn" @click="loadLabelledMetas()">Load</b-button>
        </div>

        <div class="check_tool__function__paging">
          <b-container class="check_tool__function__paging">
            <b-row>
              <b-col><button style="width: 100px;" type="button" @click.prevent="toggleBoxShow()">{{showBox}} (ESC)</button></b-col>
              <b-col><button type="button" @click.prevent="prev()">Prev</button></b-col>
              <b-col><button type="button" @click.prevent="next()">Next</button></b-col>
              <b-col><p class="label-fun__btn--font">{{current}}/{{total}}</p></b-col>
            </b-row>
          </b-container>
        </div>
      </div>

       <div class="check_tool__pannel">
         <h5 style="width:200px;">Batch:{{batch_date}}</h5>
         <p> Label Result: </p>
         <p></p>

        <sleepOcclPanel
        :propsOcclResult="propsOcclResult"
        ></sleepOcclPanel>
         
         <b-form-input 
            v-model="reason" 
            placeholder="Reject Reason" 
            class="check_tool__function__reason"
            @focus="toogleFocus"
            @blur="toogleFocus">
          </b-form-input>
          <b-button variant="info" class="check_tool__function__reason__btn" @click.prevent="reject()">Reject</b-button>
       </div>
      <imageCanvas 
        v-on:image-loaded="loadMeta"
        :probsWidth="width"
        :probsHeight="height"
        :probImageSource="image_source"
        :probsItem="ProbsItem"
        :probsBoxes="probsHeadBoxes"
        :probsLandmark="probsLandmark"
        :probsToggleBoxShow="showBox"
      ></imageCanvas>
    </div>
  </div>
</template>

<script>
   // import models
  import client from '@/api/client'
  import sleepOcclPanel from '@/components/checktool/occlResultPanel.vue';
  import imageCanvas from '@/components/checktool/ImageCanvas.vue';
  export default {
    components: { sleepOcclPanel, imageCanvas},
    props: ["probsBatchDate"],
    data() {
      return {
          width:'',
          height:'',
          image_source: 'pipeline',
          batch_type: 'sleep_occl',
          store_type: 'alert',
          batch_date:'',

          loader: null,
          // input
          email: '@yunyun.cloud',
          count: 100,
          reasons: [],
          reason: '',

          metas: [],

          // function
          showBox: 'Hide',
          current: 0,
          total: 0,
          reason_focus:false,

          // use in canvas
          ProbsItem:null,
          propsOcclResult:null,
          probsHeadBoxes: [],
          probsLandmark: []
        }
      },
      methods: {
        toggleLoading() {
          this.isLoading = !this.isLoading
        },
        toggleBoxShow() {
          if (this.metas.length == 0) return
          if (this.showBox == 'Hide') {
            this.showBox = 'Show'
          } else {
            this.showBox = 'Hide'
          }
        },
        toogleFocus() {
          this.reason_focus = !this.reason_focus
        },
        loadLabelledMetas() {
          const vm = this
          let params = {
              batch_date: this.batch_date,
              account: this.email,
              count: this.count
            }
          console.log(params)
          client.get(`metas/${this.batch_type}/random_pick`, params).then((res) => {
            vm.metas = []
            res.metas.forEach(function(item){
              item.batch_type = vm.batch_type
              vm.metas.push(item)
            })
            
            vm.total = vm.metas.length
            vm.reasons = new Array(vm.total)

            if (vm.total == 0) {
              // show message box
               this.$bvModal.msgBoxOk('No labels in this batch')
            }

            this.ProbsItem = this.metas[this.current]
          });
        },
        loadMeta() {
          let meta =  this.metas[this.current]
          let head_box = {class:'head', bbox:meta.bbox_head}
          this.probsHeadBoxes = [head_box]

          // load landmark
          this.probsLandmark = meta.landmarks
          
          // load label result to panel
          this.propsOcclResult = meta
          if ('reason' in meta) {
            this.reasons[this.current] = meta.reason
          }
          this.reason = this.reasons[this.current] 
        },
        next() {
          if (this.current < this.metas.length - 1) {
            this.current += 1
            this.ProbsItem = this.metas[this.current]
          }
        },
        prev() {
          if (this.current > 0) {
            this.current -= 1
            this.ProbsItem = this.metas[this.current]
          }
        },
        reject() {
          this.reasons[this.current] = this.reason 
          let body = {
              batch_type: this.batch_type,
              batch_date:this.batch_date,
              name: this.metas[this.current].name,
              reason: this.reason
            }
          if (!this.reason) {
              // message box
              this.$bvModal.msgBoxOk('Reason can not be empty')
            return
          }
          client.post(`meta/${this.batch_type}/reject`, null, body).then((res) => {
             this.next()
          })
        }
      },
      mounted() {
        this.width = 600
        this.height = 500
        this.batch_date = this.$route.params.batch_date
        const vm = this
        document.onkeydown = function (e) { 
          switch (e.code) {
            case 'ArrowDown':
              vm.next()
              event.preventDefault();
              break
            case 'ArrowRight':
              if (!vm.reason_focus) {
                vm.next()
                event.preventDefault();
              }
              break
            case 'ArrowUp':
              vm.prev()
              event.preventDefault();
              break
            case 'ArrowLeft':
              if (!vm.reason_focus) {
                vm.prev()
                event.preventDefault();  
              }
              break
            case 'Escape':
              vm.toggleBoxShow()
              break 
          }
        }
    },
  }
</script>